import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, CHAT_RESOLVERS } from 'cpool-constants';
import { schemaChatResolver_GetChats } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

// Visibility is derived server-side from role/context. No position gate — mutations use immediate invalidate + chain catch-up.
export const useChats = () => {
    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.CHAT,
        resolverName: CHAT_RESOLVERS.getChats,
        schema: schemaChatResolver_GetChats,
        searchParams: {},
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });
};
